// extracted by mini-css-extract-plugin
module.exports = {"weighingTransfers":"WeighingTransfers_weighingTransfers__2w9Rz","rowHeader":"WeighingTransfers_rowHeader__Al9rb","columnFlex":"WeighingTransfers_columnFlex__2jKcV"};